import { CollectorSymbol, SymbolModel, ValueSymbol } from '../model/SymbolModel'

/**
 * Check if a symbol is a ValueSymbol
 * @param symbol The symbol model to check
 * @returns Boolean
 */
export function isValueSymbol(symbol: SymbolModel): symbol is ValueSymbol {
    return 'cash' in symbol && 'start' in symbol.cash && 'end' in symbol.cash
}

/**
 * Check if a symbol is a CollectorSymbol
 * @param symbol The symbol model to check
 * @returns Boolean
 */
export function isCollectorSymbol(symbol: SymbolModel): symbol is CollectorSymbol {
    return symbol.id === 9
}
